import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { Drawer } from 'antd';
import kpiStore from '@src/globalStore/kpiStore';
import useKPI from '@src/hooks/useKPI';
import { editModeAtom } from './atoms';
import View from './components/View';
import Edit from './components/Edit';
import { StyledContainer } from './styled';

const SPIDrawer = () => {
  const [editMode, setEditMode] = useAtom(editModeAtom);
  const { forceUpdateKpiMetaConfigs } = useKPI();
  const { setIsKpiDrawerOpen, isKpiDrawerOpen } = kpiStore((state: any) => state);

  useEffect(() => {
    if (isKpiDrawerOpen) {
      forceUpdateKpiMetaConfigs();
    } else {
      setEditMode(false);
    }
  }, [isKpiDrawerOpen]);

  return (
    <Drawer
      open={isKpiDrawerOpen}
      placement="right"
      className="kpi-settings-drawer"
      onClose={() => setIsKpiDrawerOpen(false)}
      destroyOnHidden={true}
      title="KPI Configuration"
      width={575}
    >
      <StyledContainer>{editMode ? <Edit /> : <View />}</StyledContainer>
    </Drawer>
  );
};

export default SPIDrawer;
